import { render } from "./note.vue?vue&type=template&id=46eca0d7&scoped=true&ts=true"
import script from "./note.vue?vue&type=script&lang=ts"
export * from "./note.vue?vue&type=script&lang=ts"

import "./note.vue?vue&type=style&index=0&id=46eca0d7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46eca0d7"]])

export default __exports__